import { t } from 'i18next'
import { TabPanel, TabView } from 'primereact/tabview'
import React, { useState } from 'react'
import { BusinessCards } from './business-cards/BusinessCards'
import { StatisticModule } from './statistic/Statistic.module'
import { claims } from '../../../claims'
import { useAppSelector } from '../../../redux/hooks'
import { hasClaim } from '../../../util/validation/hasClaim'
import { GradeStatisticView } from '../grade-module/grade-overview/GradeStatisticView'

export const Dashboard = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const userClaims = useAppSelector((state) => state.claims)
  const requiredClaim = claims.hrm.main

  return (
    <div className={'card '}>
      {hasClaim(userClaims, requiredClaim) ? (
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header={t<string>('title.overview')}>
            <BusinessCards />
          </TabPanel>
          <TabPanel header={t<string>('title.statistics')}>
            <StatisticModule />
          </TabPanel>
          <TabPanel header={t<string>('title.statistics_grade')}>
            <GradeStatisticView />
          </TabPanel>
        </TabView>
      ) : (
        <>
          <BusinessCards />
        </>
      )}
      <br />
    </div>
  )
}